import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/images/quotation-mark-2.png'


const _withScopeId = n => (_pushScopeId("data-v-145e7ef0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ptb-100" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-title mw-600" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "top-title" }, "TESTIMONIALS"),
  /*#__PURE__*/_createElementVNode("h2", null, "We help to achieve customers business goals")
], -1))
const _hoisted_4 = { class: "row align-items-center" }
const _hoisted_5 = { class: "col-lg-4" }
const _hoisted_6 = { class: "testimonial-img position-relative mb-4 mb-lg-0 d-inline-block" }
const _hoisted_7 = ["src"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "position-absolute end-0 top-0",
  alt: "quotation-mark-2"
}, null, -1))
const _hoisted_9 = { class: "col-lg-8" }
const _hoisted_10 = { class: "testimonial-quot" }
const _hoisted_11 = { class: "testimonial-info ms-0 text-start" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "swiper-controller testimonials-controller-three" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "controller-icon prev" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "ri-arrow-left-line" })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "controller-icon next" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "ri-arrow-right-line" })
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_swiper, {
        spaceBetween: 25,
        slidesPerView: 1,
        preventClicks: true,
        loop: true,
        autoplay: {
          delay: 4000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        },
        navigation: {
          nextEl: '.next',
          prevEl: '.prev',
        },
        modules: _ctx.modules,
        class: "testimonial-slide testimonials-wrappers"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.testimonials, (testimonial) => {
            return (_openBlock(), _createBlock(_component_swiper_slide, {
              key: testimonial.id
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("img", {
                        src: testimonial.image,
                        alt: "testimonials"
                      }, null, 8, _hoisted_7),
                      _hoisted_8
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("p", null, _toDisplayString(testimonial.description), 1),
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("h3", null, _toDisplayString(testimonial.name), 1),
                        _createElementVNode("span", null, _toDisplayString(testimonial.designation), 1)
                      ])
                    ])
                  ])
                ])
              ]),
              _: 2
            }, 1024))
          }), 128)),
          _hoisted_12
        ]),
        _: 1
      }, 8, ["modules"])
    ])
  ]))
}